<template>
  <div class="payment-wrap">
    <div v-if="type !== PAYMENT_TYPE.ONLY_SUBS_PAYMENT" class="normal-payment">
      <div class="title">일반결제</div>

      <div v-for="(pay, idx) in normalPayTypes" :key="`normal_pay_${pay.value}`" class="normal-payment-item" :class="[`normal-pay-item-${idx}`]">
        <input type="radio" class="normal-payment-input" v-model="selectedPay" :value="`normal__${pay.value}`" :id="`normal_pay_${pay.value}`">
        <label v-if="pay.img" :for="`normal_pay_${pay.value}`">
          <img :src="pay.img" :class="pay.value" alt="">
        </label>
        <label v-else :for="`normal_pay_${pay.value}`">{{ pay.label }}</label>
      </div>
    </div>
    <div v-if="type !== PAYMENT_TYPE.ONLY_NORMAL_PAYMENT" class="subscribe-payment">
      <div class="title">
        내 결제수단
        <router-link v-if="$route.path !== '/my/profile'" to="/my/payment" class="link-my-payment">관리</router-link>
      </div>

      <div class="payment-card-list">
        <div v-for="(payment, idx) in payments" :key="`payment_card_${idx}`" class="payment-card-item">
          <input type="radio" v-model="selectedPay" :value="`payment__${payment.id}`" :id="`normal_pay_card_${idx}`">
          <label class="payment-card-label" :for="`normal_pay_card_${idx}`">
            <span class="name">{{ payment.card_name }}</span>
            <span class="number">{{ payment.card_number }}</span>
          </label>
        </div>

        <button v-if="$route.path === '/my/profile'" class="payment-card-item btn-add-card">
          <i class="xi-plus-circle"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _CONST from "@/store/const";
// import apiUser from "@/api/user";

export default {
  name: "TheEstimatePaymentV2",
  props: ['includeNormalPayment', 'includeSubscribePayment', 'payments', 'type', 'modelValue'],
  emits: ['update:modelValue'],
  data() {
    return {
      normalPayTypes: _CONST.PAYMENT.METHODS,
      PAYMENT_TYPE: _CONST.PAYMENT_TYPE,
      payType: null,
      selectedPay: null,
    }
  },
  watch: {
    selectedPay() {
      this.payType = this.selectedPay.split('__')[0];
      let val = this.selectedPay.split('__')[1];

      this.$emit('update:modelValue', this.payType === 'normal' ? val : Number(val));
    }
  },
  methods: {
    // addPayment() {
    //   const { IMP } = window;
    //   IMP.init(_CONST.PAYMENT.USERCODE);
    //
    //   let url = '/storage/payment/complete/mobile';
    //
    //   var mobileRedirectUrl = "http://127.0.0.1:8000" + url;
    //
    //   if (window.location.host === "dev.mrbob.kr") {
    //     mobileRedirectUrl = "https://dev.mrbob.kr" + url;
    //   } else if (window.location.host === "mrbob.kr") {
    //     mobileRedirectUrl = "https://mrbob.kr" + url;
    //   }
    //
    //
    //   let pg = this.type === 'STORAGE' ? 'tosspayments' : 'tosspayments';
    //
    //   if (window.location.host === 'localhost:8080' || window.location.host === '127.0.0.1:8080' || window.location.host === 'dev.mrbob.kr') {
    //     pg = this.type === 'STORAGE' ? 'tosspayments.iamporttest_4' : 'tosspayments.iamporttest_3';
    //   }
    //
    // }
  },
}
</script>

<style scoped lang="scss">
.payment-wrap {
  .title {
    padding-bottom: 10px;
  }

  .normal-payment-item {
    display: inline-block;
    margin-bottom: 10px;

  }

  .normal-payment + .subscribe-payment {
    margin-top: 20px;
  }

  input[type=radio] {
    opacity: 0;
    width: 0;

    &.normal-payment-input + label {
      cursor: pointer;
      display: inline-block;
      padding: 0 20px;
      height: 40px;

      border-radius: 6px;
      border: 1px solid #D0D4DC;

      line-height: 40px;
      text-align: center;

      > img {
        height: 18px;
        vertical-align: top;
        margin-top: 10px;

        &.kakaopay {
          height: 22px;
          margin-top: 8px;
        }
      }
    }
  }

  input[type=radio]:checked + label,
  input[type=radio]:checked + .payment-card-label {
    border: 2px solid $sub-color !important;
  }

  .payment-card-list {
    white-space: nowrap;
    overflow-x: auto;
  }

  .payment-card-item {
    position: relative;
    display: inline-block;
    height: 150px;
    width: 250px;
    vertical-align: top;
    cursor: pointer;

    & + .payment-card-item {
      margin-left: 10px;
    }
  }

  .payment-card-label {
    position: relative;
    height: 100%;
    width: 100%;
    display: inline-block;
    background-color: #ededed;
    border: 2px solid #ededed;
    border-radius: 6px;
    padding: 13px 15px;
    cursor: pointer;

    .number {
      position: absolute;
      bottom: 20px;
      right: 15px;
      font-weight: bold;
      font-size: 18px;

      //&::before {
      //  content: '**** **** **** ';
      //  vertical-align: sub;
      //}
      //&::after {
      //  content: '*';
      //  vertical-align: sub;
      //}
    }
  }

  .btn-add-card {
    border: 2px dashed #c2c2c2;
    border-radius: 6px;
    background-color: #fff;

    i {
      font-size: 30px;
      color: #c2c2c2;
    }
  }

  .link-my-payment {
    padding: 2px 5px;
    background-color: #d2d2d2;
    border-radius: 5px;
    color: #000;
    text-decoration: none;
    font-size: 11px;
    margin-left: 5px;
    //float: right;
  }

  @include respond(not-mobile) {
    .normal-payment-item + .normal-payment-item {
      margin-left: 10px;
    }
  }
  @include respond(mobile) {
    .normal-payment-item {
      width: 48%;

      label {
        width: 100%;
      }
    }
    .normal-payment-item:nth-child(2n+1) {
      margin-left: 4%;
    }
  }
}

</style>
